import { render, staticRenderFns } from "./AddCard.vue?vue&type=template&id=410161a6&scoped=true&lang=pug&"
import script from "./AddCard.vue?vue&type=script&lang=js&"
export * from "./AddCard.vue?vue&type=script&lang=js&"
import style0 from "./AddCard.vue?vue&type=style&index=0&id=410161a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410161a6",
  null
  
)

export default component.exports